export enum FeeFallbackTransaction {
  ManualKeyEntry = 'MANUAL_KEYENTRY',
  NonEMV = 'NON_EMV',
}
